module.exports = __webpack_public_path__ + "static/media/d6_logo_white.911fe712.svg";